module.exports = __webpack_public_path__ + "static/media/guatemalaflag.cdd2f622.png";